var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-select',{staticStyle:{"width":"160px"},attrs:{"default-value":_vm.current.$id},on:{"change":_vm.handleChange}},_vm._l((_vm.data),function(item){return _c('a-select-option',{key:item.$id},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }